import { createDataModule } from '@perpay-web/data-module/createDataModule';
import {
    fetchUserInfoForDataModule,
    fetchUserInfoSuccess,
    fetchUserInfoError,
    fetchUserInfoReset,
} from '@perpay-web/fintech/actions/entities/userInfo';
import { PremiumCardGroupName } from '@perpay-web/fintech/constants/partnerOnboardingCodes';
import { formatUserInfo } from '@perpay-web/fintech/selectors/entities/userInfo';

const FetchUserInfoDataModule = createDataModule({
    dataRequest: fetchUserInfoForDataModule,
    dataSuccess: fetchUserInfoSuccess,
    dataError: fetchUserInfoError,
    dataReset: fetchUserInfoReset,
});

const getRoot = (state) => state.dataModules.fetchUserInfo;
const initialValue = {};

export const fetchUserInfoDataModule = FetchUserInfoDataModule({
    getRoot,
    initialValue,
});

export const getUserInfo = (state) =>
    formatUserInfo(fetchUserInfoDataModule.getData(state));

export const getFirstName = (state) =>
    fetchUserInfoDataModule.getData(state).firstName || '';

export const getLastName = (state) =>
    fetchUserInfoDataModule.getData(state).lastName || '';

export const getSsnIsVerified = (state) =>
    fetchUserInfoDataModule.getData(state).ssnIsVerified || false;

export const getUserAffiliateGroupCodes = (state) =>
    fetchUserInfoDataModule.getData(state).affiliateGroupCodes || [];

export const getAffiliateOfferCode = (state) =>
    fetchUserInfoDataModule.getData(state).affiliateOfferCode || '';

export const getAffiliateOfferAmount = (state) =>
    getAffiliateOfferCode(state).slice(2) || null;

export const getSsn = (state) =>
    fetchUserInfoDataModule.getData(state).ssn || '';

export const getVisibleSsn = (state) =>
    fetchUserInfoDataModule.getData(state).visibleSsn || '';

export const getDateOfBirth = (state) =>
    fetchUserInfoDataModule.getData(state).dateOfBirth || '';

export const getEmail = (state) => {
    const { email } = fetchUserInfoDataModule.getData(state);
    if (!email) {
        return '';
    }
    return email;
};

export const getIsExistingUserWithPassword = (state) => {
    const { signupRequirements } = fetchUserInfoDataModule.getData(state);
    if (!signupRequirements) {
        return false;
    }
    return !signupRequirements.includes('password_set');
};

/**
 * @deprecated use getStreetAddr, getCity, getState, getZipcode instead
 */
export const getAddress = (state) => ({
    street1: fetchUserInfoDataModule.getData(state).streetAddr,
    street2: '',
    city: fetchUserInfoDataModule.getData(state).city,
    state: fetchUserInfoDataModule.getData(state).state,
    zipcode: fetchUserInfoDataModule.getData(state).zipcode,
});

export const getStreetAddr = (state) =>
    fetchUserInfoDataModule.getData(state).streetAddr || '';

export const getCity = (state) =>
    fetchUserInfoDataModule.getData(state).city || '';

export const getState = (state) =>
    fetchUserInfoDataModule.getData(state).state || '';

export const getZipcode = (state) =>
    fetchUserInfoDataModule.getData(state).zipcode || '';

export const hasBillingAddress = (state) => {
    const streetAddr = getStreetAddr(state);
    const city = getCity(state);
    const addressState = getState(state);
    const zipcode = getZipcode(state);

    return Boolean(streetAddr && city && addressState && zipcode);
};

export const getIsPhoneVerified = (state) =>
    fetchUserInfoDataModule.getData(state).phoneVerified || false;

const getUserCardApplicationGroups = (state) =>
    fetchUserInfoDataModule.getData(state).cardApplicationGroups || [];

export const isUserInPremiumCardGroup = (state) =>
    getUserCardApplicationGroups(state).includes(PremiumCardGroupName);

export const getPhoneNumber = (state) =>
    fetchUserInfoDataModule.getData(state).mobilePhone || '';
